import React from 'react';

interface HalfSplashProps extends React.HTMLAttributes<HTMLDivElement> {
  logo?: React.ReactNode;
  description?: React.ReactNode;
  footer?: React.ReactNode;
  backgroundImage?: string;
}

const HalfSplash: React.FC<HalfSplashProps> = ({ logo, description, footer, backgroundImage, ...props }) => {
  return (
    <div className={`relative w-[40%] h-screen hidden md:block ${props.className || ''}`}>
      <div className="flex flex-col h-full">
        <div
          className={`flex-1 flex flex-col items-center box-border p-10 ${backgroundImage ? 'bg-cover' : ''} bg-black bg-center`}
          style={{
            backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
          }}
        >
          <div className="flex flex-1 flex-col justify-center w-full">
            {logo && <div className="max-w-[300px]">{logo}</div>}
            {description && description}
          </div>
          {footer && <div className="w-full">{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default HalfSplash;
